export default __webpack_public_path__ + "static/media/green-check.cb81471a.png";